import Api from '@/api/api.js'

export default {
    async getSubjects() {
        return Api().get('/auth/subjects').then(t => {
            for (var i=0;i<t.data.length;i++) {
                t.data[i].VisibleName = (t.data[i].IsCompany) ? t.data[i].CompanyName : t.data[i].FirstName + ' ' + t.data[i].LastName;
            }
            return t;
        });
    },
    async getSubject(id) {
        return Api().get('/auth/subjects/'+id);
    },
    async newSubject() {
        return Api().post('/auth/subjects/new');
    },
    async saveSubject(id, subject) {
        return Api().post('/auth/subjects/'+id, subject);
    },
    async deleteSubject(id) {
        return Api().delete('/auth/subjects/'+id);
    },
    async indicePaCodFisc(cf) {
        return Api().get('/auth/indicepa/ws01_sfe/'+cf);
    },
    async indicePaCodFiscDatiCompleti(cf) {
        return Api().get('/auth/indicepa/ws01_sfe_ws05_amm/'+cf);
    }
}